import React from "react";
import CotizacionDatosPersonales from "../../components/CotizacionHogar/CotizacionDatosPersonales";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import {
  listarProvinciasHogarFetch,
  listarRelatividadesHogarFetch,
} from "../../redux/actions/aCotizacion";

import { obtenerDatosHogar } from "../../utils/validaciones";

class ContainerCotizacionDatosPersonales extends React.Component {
  constructor(props) {
    super(props);
  }

  async componentDidMount() {
   

    var codigoEspecial = "hogar";
    const queryParams = new URLSearchParams(this.props.location.search);

    

    let codigoProductoEspecial = queryParams.get("producto");

    const datosProductoObtenido = obtenerDatosHogar(codigoProductoEspecial)

    await this.props.limpiarProvinciasHogar(datosProductoObtenido.codigoEspecial);
    let datosRelatividades = {
      empresa: "AIGMETROPOLITANA",
      ramo: datosProductoObtenido.ramo,
    };
    await this.props.listarRelatividadesHogar(datosRelatividades);
  }

  render() {  

    return (
      <main className="bg-light">
        <div className="cr-content container-fluid">
          <div className="container-body-spaces">
            <CotizacionDatosPersonales/>          
          </div>
        </div>
      </main>
    );
  }
}

const mapStateToProps = state => ({
});

const mapDispatchToProps = (dispatch) => {
  return {
    limpiarProvinciasHogar: (ramo) =>
      dispatch(listarProvinciasHogarFetch(ramo)),
    listarRelatividadesHogar: (param) =>
      dispatch(listarRelatividadesHogarFetch(param))
  };
};

export default withRouter(
  connect(
    null,
    mapDispatchToProps
  )(ContainerCotizacionDatosPersonales)
);
